export { default } from './SWAvailableAppsCarouselIcons';
